// extracted by mini-css-extract-plugin
module.exports = {"anchor":"handover_link__anchor__WdhCI"};